import React from 'react';
import DiscoPanda from './components/DiscoPanda';
import './index.css';

const App: React.FC = () => {
    return (
        <div className="bg-purple-900 min-h-screen text-white font-sans">
            {/* <Header /> */}
            <DiscoPanda />
            {/* <InfoCards /> */}
        </div>
    );
};

export default App;